import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var SvgRedditFilled = function SvgRedditFilled(_a) {
  var _b = _a,
      size = _b.size,
      _b$title = _b.title,
      title = _b$title === void 0 ? "RedditFilled" : _b$title,
      props = __objRest(_b, ["size", "title"]);

  return (
    /* @__PURE__ */
    React.createElement("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      width: size,
      height: size,
      "data-icon-name": title,
      "aria-label": title,
      role: "presentation"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "currentColor",
      d: "M20 11.867a1.935 1.935 0 00-1.933-1.934c-.467 0-.867.134-1.2.4-1.2-.733-2.667-1.2-4.267-1.266l.8-2.6L15.667 7a1.6 1.6 0 001.6 1.467c.866 0 1.6-.734 1.6-1.6 0-.867-.734-1.6-1.6-1.6-.6 0-1.134.333-1.4.866l-2.667-.6a.453.453 0 00-.533.267l-1 3.267c-1.667.066-3.334.466-4.534 1.266-.333-.266-.733-.4-1.2-.4A1.935 1.935 0 004 11.867c0 .666.333 1.266.8 1.6v.466c0 1.334.8 2.534 2.2 3.467 1.333.867 3.133 1.333 5 1.333s3.667-.466 5-1.333c1.4-.933 2.2-2.133 2.2-3.467v-.4c.467-.4.8-1 .8-1.666zm-2.667-5.734c.4 0 .734.334.734.734a.74.74 0 01-.734.733.74.74 0 01-.733-.733c0-.4.333-.734.733-.734zm-8.8 6.934c0-.6.534-1.067 1.067-1.067.6 0 1.067.533 1.067 1.067 0 .533-.467 1.066-1.067 1.066-.533 0-1.067-.466-1.067-1.066zm6.134 3.133c-.534.533-1.4.8-2.6.8-1.2 0-2.067-.267-2.6-.8-.2-.2-.2-.467 0-.6.2-.2.466-.2.6 0 .4.4 1.066.6 2 .6.933 0 1.6-.2 2-.6.2-.2.466-.2.6 0 .133.2.133.467 0 .6zm-.267-2.067c-.6 0-1.133-.466-1.133-1.066 0-.6.533-1.067 1.133-1.067s1.067.533 1.067 1.067c0 .533-.467 1.066-1.067 1.066z"
    }))
  );
};

var RedditFilled = withIcon(SvgRedditFilled);
export { RedditFilled as default };